import { styled } from '@/stitches.config';

export const StyledRadioContainer = styled('label', {
  border: '2px solid $darkBlue300',
  borderRadius: '$radii$4',
  color: '$darkBlue300',
  cursor: 'pointer',
  display: 'inline-flex',
  fontWeight: '$medium',
  justifyContent: 'center',
  justifySelf: 'space-between',
  margin: '$2',
  '&:hover': {
    backgroundColor: '$darkBlue700',
  },
  '&:active': {
    backgroundColor: '$darkBlue600',
  },
  variants: {
    checked: {
      true: {
        backgroundColor: '$darkBlue300',
        color: '$white',
        '&:hover': {
          backgroundColor: '$darkBlue300',
        },
      },
    },
    disabled: {
      true: {
        borderColor: '$darkGray700',
        cursor: 'not-allowed',
        color: '$darkGray400',
        '&:hover': {
          backgroundColor: 'transparent',
        },
        '&:active': {
          backgroundColor: 'transparent',
        },
      },
    },
  },
  width: '30%',
  minWidth: '140px',
});

export const StyledRadio = styled('input', {
  border: 'none',
  margin: '$0',
  opacity: '0',
  overflow: 'hidden',
  pointerEvents: 'none',
  position: 'absolute',
  whiteSpace: 'nowrap',
});
